<e-list header="Rechten">
  <div slot="header" style="width: 100%" class="d-flex justify-content-between">
    <div>
      <button
        eBtn
        class="auth-square-btn"
        color="secondary"
        size="sm"
        squared
        icon="check-double"
        tooltip="Geef rechten voor alle pagina's en features"
        (click)="selectAll()"
      ></button>
      <tree-view-tools [treeControl]="treeControl"></tree-view-tools>
    </div>

    <div>
      <button
        eBtn
        class="auth-square-btn"
        color="highlight"
        textColor="primary-50"
        size="sm"
        icon="undo"
        (click)="onUndoAll()"
        [disabled]="!dirty"
        squared
      ></button>

      <button
        class="ml-2"
        eBtn
        color="primary"
        size="sm"
        icon="save"
        (click)="onSave()"
        [disabled]="!dirty || saving"
        >
        Opslaan
      </button>
    </div>
  </div>

  <div class="auth-tree-panel">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <mat-tree-node *matTreeNodeDef="let node">
        <div
          (click)="treeControl.toggle(node)"
          style="width: 100%; border-bottom: var(--between-highlight-and-separator) 1px solid"
          class="auth-row py-3 pr-3 d-flex align-items-baseline hover-highlight"
          [style.padding-left]="1 + node.level + 'em'"
          [class.clickable]="node.navigationItem.hasChildren"
          [class.auth-row--leaf]="!node.navigationItem.hasChildren"
          >
          <div style="flex: 1">
            @if (!node.navigationItem.isRoot) {
              <button
                eBtn
                class="auth-toggle"
                [class.auth-toggle--on]="navigationItemsSelectionForm.isSelected(node.navigationItem)"
              [textColor]="
                navigationItemsSelectionForm.isSelected(node.navigationItem) ? 'success' : 'danger'
              "
                size="sm"
              [icon]="
                navigationItemsSelectionForm.isSelected(node.navigationItem) ? 'check' : 'ban'
              "
                squared
                (click)="toggleNavigationItem(node.navigationItem, $event)"
              ></button>
            }
            <navigation-item-label
              style="width: 90%"
              [navigationItem]="node.navigationItem"
            ></navigation-item-label>
            @if (node.navigationItem.regularFeatures.length) {
              <div
                class="mt-3 pl-4"
                style="font-size: 1em !important"
                >
                @for (feature of node.navigationItem.regularFeatures; track trackByFeatureId($index, feature)) {
                  <div class="mt-2 d-flex">
                    <feature-access-toggler
                  [isAuthorized]="
                    featureAuthorizationSelectionForm.isSelected(feature, node.navigationItem)
                  "
                      [feature]="feature"
                      [node]="node"
                      (toggleFeature)="toggleFeature($event[0], $event[1])"
                    ></feature-access-toggler>
                    <div style="flex: 1">
                      <feature-label>{{ feature.name }} </feature-label>
                      @for (tag of feature.tags; track tag) {
                        <span class="pl-1">
                          <e-badge color="elegant" small>
                            {{ tag }}
                          </e-badge>
                        </span>
                      }
                      @if (feature.requiredDeviceTypes?.length) {
                        <e-card2
                          padding="2"
                          class="mt-2"
                          >
                          <ng-template eCardHeader>
                            <span style="font-size: 1rem"> Kan enkel gebruikt worden bij:
                            </span>
                          </ng-template>
                          <feature-restrictions-indicators
                            class="h-100"
                            [feature]="feature"
                          ></feature-restrictions-indicators>
                        </e-card2>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          @if (node.navigationItem.hasChildren) {
            <i
              eIcon
              [icon]="treeControl.isExpanded(node) ? 'chevron-down' : 'chevron-right'"
            ></i>
          }
        </div>
        <hr />
      </mat-tree-node>
    </mat-tree>
  </div>
</e-list>
